// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../../components/Table";
// Engine
import { axiosAPI } from "../../../../engine/config/axios";

const Events:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const gridParams = {
    grids: [{ name: 'events', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    api={axiosAPI.settings.events.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="events"
    sortingMode="multiple"
  />;
}

function EventsPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<Events hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default EventsPortal;
